import dayjs from 'dayjs';

const parseHour = (time) => dayjs(`2000-1-1-${time}`, 'YYYY-M-D-HH:mm').hour();
const parseMinute = (time) => dayjs(`2000-1-1-${time}`, 'YYYY-M-D-HH:mm').minute();

export { parseHour, parseMinute };
